// extracted by mini-css-extract-plugin
export default {"logoImg":"AdminMobileStartPage_logoImg__xX+P+","logoTxt":"AdminMobileStartPage_logoTxt__zkFX2"};